import React from "react"

const MileLog = ({ log }) => (
    <div>
        {log.date} - {log.miles} miles ({log.comment})
    </div>
)

export default MileLog